module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_L3-2c7b7653028b6ec8764f931a43efaf22.png";